module.exports = __webpack_public_path__ + "static/media/card-boosters-bg.36a1bfb2.svg";